import { mapLink } from '@websrc/DataMappers/mapLink'
import React, { ComponentPropsWithoutRef } from 'react'

import * as SC from './SpotLink.style'

export interface SpotLinkButtonProps extends ComponentPropsWithoutRef<'button'> {
  link?: ReturnType<typeof mapLink>
  ctaType: SC.SpotLinkTypes
  ctaVariant?: SC.SpotLinkVariants
}

export function SpotLinkButton({
  link,
  ctaType,
  ctaVariant = 'blue',
  ...buttonProps
}: SpotLinkButtonProps) {
  if (!link || !link.cta_text) return null

  return (
    <SC.StyledButton ctaType={ctaType ?? 'secondary'} ctaVariant={ctaVariant} {...buttonProps} />
  )
}
